<script lang="ts">
  import { animationsConfig } from "../config/animations";
  import LottieAnimation from "./LottieAnimation.svelte";
  import { assetsProgress } from "../store/AppState";

  export let onLoad: () => void;

  $: loadedCounter = 0;

  const handleAnimationLoad = () => {
    loadedCounter++;
    $assetsProgress += 1;
    if (loadedCounter === animationsConfig.length) {
      onLoad();
    }
  };
</script>

<div
  class="animations-container"
  style={`--visibility: ${
    loadedCounter >= animationsConfig.length ? "visible" : "hidden"
  }`}
>
  {#each animationsConfig as item, index}
    <LottieAnimation
      config={item}
      {index}
      onLoad={() => handleAnimationLoad()}
    />
  {/each}
</div>

<style>
  .animations-container {
    visibility: var(--visibility);
  }
</style>
